import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  CLONE_RESULTS_SUCCESS_TEXT,
  CLONE_RESULTS_TITLE,
  CLONE_RESULTS_SUCCESS_TITLE,
  CLONE_STATUS_CLONING,
  CLONE_STATUS_SUCCESS,
  CLONE_RESULTS_BUTTON_TEXT,
  VIEWS,
} from "../../constants";
import { FormInput, Loader, Modal } from "../../UIKit/components";
import {
  ButtonWrapper,
  ModalBodyWrapper,
  PageSection,
  ParagraphText,
  PrimaryButton,
} from "../../UIKit/styles";

export default function SummaryModal({
  isOpen,
  onModalClose,
  allowClose,
  modalContent,
  modalTitle
}) {

  const getModalContent = () => {
    return modalContent ? modalContent : null;
  };

  const getModalTitle = () => {
    return modalTitle ? modalTitle : null;
  };

  return (
    <Modal
      isOpen={isOpen}
      title={getModalTitle()}
      allowClose={allowClose}
      onClose={onModalClose}
      body={
        <ModalBodyWrapper>
          <>{getModalContent()}</>            
        </ModalBodyWrapper>
      }
    />
  );
}
